"use client";

import { ArrowRight, Play, Youtube, Eye, Layers, Calendar, Zap } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Engine() {
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const stats = [];
  return <section data-section-id="12249" id="the-creative-engine" className="relative bg-background text-foreground pt-16 pb-8 md:pt-20 md:pb-12 px-6 md:px-12 overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full pointer-events-none overflow-hidden">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-primary/10 blur-[120px] rounded-lg" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-secondary/10 blur-[120px] rounded-lg" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div ref={heroRef} className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-center" style={{
        opacity: heroVisible ? 1 : 0,
        transform: heroVisible ? "translateY(0)" : "translateY(20px)",
        transition: "all 0.8s cubic-bezier(0.16, 1, 0.3, 1)"
      }}>
          {}
          <div className="lg:col-span-7 flex flex-col gap-6 md:gap-8">
            <div>
              <Badge variant="outline" className="bg-surface-raised border-primary/30 text-primary px-4 py-1.5 rounded-lg text-[10px] font-mono tracking-[0.2em] uppercase flex items-center gap-2">
                <Zap className="size-3 fill-current" />
                Digital Marketer & Content Creator
              </Badge>
            </div>

            <h1 className="font-default font-extrabold text-foreground leading-[1.1] tracking-tighter text-4xl sm:text-6xl md:text-7xl lg:text-8xl">
              I Create.<br />
              I Strategize.<br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary">
                I Grow Brands.
              </span>
            </h1>

            <p className="text-muted-foreground text-lg md:text-xl max-w-[50ch] leading-relaxed">
              Results-driven Digital Marketer, Content Creator & Web Specialist with a proven track record of growing brands and delivering measurable impact.
            </p>

            <div className="flex flex-wrap gap-4 pt-4">
              <Button asChild className="bg-gradient-to-r from-primary to-secondary text-white hover:shadow-[0_0_20px_rgba(138,72,243,0.4)] hover:scale-105 transition-all duration-300 rounded-xl px-8 py-7 h-auto text-base font-semibold">
                <Link to="/PortfolioPage">
                  View My Work
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
              
              <Button asChild variant="outline" className="bg-transparent border-primary/50 text-foreground hover:bg-primary/10 rounded-lg px-8 py-7 h-auto text-base font-semibold group">
                
              </Button>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative">
            
          </div>
        </div>

        {}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mt-8 md:mt-12">
          {stats.map((stat, i) => <div key={i} data-index={i} className="bg-card border border-white/5 p-6 md:p-8 rounded-2xl flex flex-col gap-4 hover:border-primary/30 transition-all duration-300 group">
              <div className="size-12 rounded-xl bg-primary/10 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                {stat.icon}
              </div>
              <div className="flex flex-col">
                <span className="text-3xl md:text-4xl font-bold text-foreground tracking-tight">
                  {stat.value}
                </span>
                <span className="text-sm text-muted-foreground font-medium mt-1">
                  {stat.label}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}